import { useState, useMemo } from "react";
import { toast } from "sonner";
import { Copy, Download, Mail, User, Phone, Globe, MapPin, Briefcase, Check } from "lucide-react";

const MADYMARK_LOGO = "https://madymark.com.tr/madymark_logo.png";
const DANDINIDAS_LOGO = "https://madymark.com.tr/dandinidas_logo.png";

const buildSignatureHTML = (d) => {
  const name = d.name || "Ad Soyad";
  const title = d.title || "Pozisyon";
  const mobile = d.mobile || "";
  const phone = d.phone || "";
  const email = d.email || "";
  const web = d.web || "madymark.com";
  const address = d.address || "Tahtakale Mah. Fırat Cad. No 88, İstanbul · Türkiye";
  const telHref = (p) => p ? `tel:${p.replace(/[^+\d]/g, "")}` : "#";

  const logoBox = (src, alt) => `<td style="padding:4px;background:#FFFFFF;border:1px solid #E2E8F0;border-radius:12px;" align="center"><img src="${src}" alt="${alt}" width="80" height="80" style="display:block;border:0;outline:none;width:80px;height:80px;border-radius:8px;"></td>`;

  return `<table cellpadding="0" cellspacing="0" border="0" style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;color:#1E293B;font-size:13px;line-height:1.5;">
  <tr>
    <td valign="top" style="padding:0 20px 0 0;border-right:3px solid #1E2A9C;">
      <table cellpadding="0" cellspacing="0" border="0">
        <tr>${logoBox(MADYMARK_LOGO, "MADYMARK")}</tr>
        <tr><td style="height:10px;line-height:10px;font-size:0;">&nbsp;</td></tr>
        <tr>${logoBox(DANDINIDAS_LOGO, "DANDİNİDAŞ")}</tr>
      </table>
    </td>
    <td valign="top" style="padding:0 0 0 20px;">
      <table cellpadding="0" cellspacing="0" border="0" style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;">
        <tr><td style="font-size:18px;font-weight:700;color:#1E2A9C;letter-spacing:0.3px;padding-bottom:2px;">${name}</td></tr>
        <tr><td style="font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:1.2px;padding-bottom:4px;">${title}</td></tr>
        <tr><td style="font-size:11px;font-weight:700;color:#1E2A9C;letter-spacing:0.6px;padding-bottom:10px;">MADYMARK İÇ VE DIŞ TİCARET SANAYİ ANONİM ŞİRKETİ</td></tr>
        <tr><td style="padding-bottom:10px;"><div style="width:40px;height:2px;background:#C8102E;line-height:2px;font-size:0;">&nbsp;</div></td></tr>
        ${mobile ? `<tr><td style="font-size:13px;color:#1E293B;padding-bottom:4px;line-height:1.6;"><span style="color:#1E2A9C;font-weight:700;">M</span>&nbsp;<a href="${telHref(mobile)}" style="color:#1E293B;text-decoration:none;">${mobile}</a></td></tr>` : ""}
        ${phone ? `<tr><td style="font-size:13px;color:#1E293B;padding-bottom:4px;line-height:1.6;"><span style="color:#1E2A9C;font-weight:700;">T</span>&nbsp;<a href="${telHref(phone)}" style="color:#1E293B;text-decoration:none;">${phone}</a></td></tr>` : ""}
        ${email ? `<tr><td style="font-size:13px;color:#1E293B;padding-bottom:4px;line-height:1.6;"><span style="color:#1E2A9C;font-weight:700;">E</span>&nbsp;<a href="mailto:${email}" style="color:#1E293B;text-decoration:none;">${email}</a></td></tr>` : ""}
        ${web ? `<tr><td style="font-size:13px;color:#1E293B;padding-bottom:4px;line-height:1.6;"><span style="color:#1E2A9C;font-weight:700;">W</span>&nbsp;<a href="https://${web.replace(/^https?:\/\//, "")}" style="color:#1E293B;text-decoration:none;">${web}</a></td></tr>` : ""}
        ${address ? `<tr><td style="font-size:12px;color:#64748B;padding-top:6px;line-height:1.5;max-width:360px;">${address}</td></tr>` : ""}
      </table>
    </td>
  </tr>
</table>`;
};

export default function EmailSignature() {
  const [data, setData] = useState({
    name: "Yusuf OZ",
    title: "General Manager",
    mobile: "+90 552 213 03 44",
    phone: "0859 244 45 44",
    email: "yusuf@madymark.com",
    web: "madymark.com",
    address: "Tahtakale Mah. Fırat Cad. No 88, İstanbul · Türkiye",
  });

  const html = useMemo(() => buildSignatureHTML(data), [data]);
  const update = (k, v) => setData({ ...data, [k]: v });

  const copyHTML = async () => {
    try {
      await navigator.clipboard.writeText(html);
      toast.success("HTML panoya kopyalandı");
    } catch {
      toast.error("Kopyalama başarısız");
    }
  };

  const copyRich = async () => {
    try {
      const blob = new Blob([html], { type: "text/html" });
      const text = new Blob([html.replace(/<[^>]+>/g, "")], { type: "text/plain" });
      await navigator.clipboard.write([
        new ClipboardItem({ "text/html": blob, "text/plain": text }),
      ]);
      toast.success("Zengin metin kopyalandı — mail imza alanına yapıştırın");
    } catch {
      toast.error("Zengin metin kopyalanamadı — HTML kopyalamayı deneyin");
    }
  };

  const downloadHTML = () => {
    const full = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Email Signature - ${data.name}</title></head><body>${html}</body></html>`;
    const blob = new Blob([full], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `imza-${data.name.toLowerCase().replace(/\s+/g, "-")}.html`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("İmza dosyası indirildi");
  };

  const Field = ({ label, k, icon: Icon, placeholder, type = "text", textarea }) => (
    <div>
      <label className="text-xs uppercase font-bold text-slate-500 tracking-widest flex items-center gap-2 mb-1">
        <Icon className="w-3.5 h-3.5" /> {label}
      </label>
      {textarea ? (
        <textarea
          data-testid={`sig-${k}`}
          value={data[k]}
          onChange={(e) => update(k, e.target.value)}
          placeholder={placeholder}
          rows={2}
          className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:border-[#1E2A9C] outline-none text-sm"
        />
      ) : (
        <input
          data-testid={`sig-${k}`}
          type={type}
          value={data[k]}
          onChange={(e) => update(k, e.target.value)}
          placeholder={placeholder}
          className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:border-[#1E2A9C] outline-none text-sm"
        />
      )}
    </div>
  );

  return (
    <div className="space-y-6" data-testid="email-signature-page">
      <div>
        <h1 className="text-3xl font-black text-slate-900">Mail İmzası</h1>
        <p className="text-slate-500 mt-1">Çalışanlar için kurumsal e-posta imzası oluştur · Apple Mail & tüm mail istemcileriyle uyumlu</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Form */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
          <div className="text-xs uppercase font-bold text-slate-500 tracking-widest mb-2">Çalışan Bilgileri</div>
          <Field label="Ad Soyad" k="name" icon={User} placeholder="Yusuf OZ" />
          <Field label="Pozisyon" k="title" icon={Briefcase} placeholder="General Manager" />
          <div className="grid grid-cols-2 gap-4">
            <Field label="Cep" k="mobile" icon={Phone} placeholder="+90 ..." />
            <Field label="Sabit" k="phone" icon={Phone} placeholder="0xxx xxx xx xx" />
          </div>
          <Field label="E-posta" k="email" icon={Mail} type="email" placeholder="ad@madymark.com" />
          <Field label="Web" k="web" icon={Globe} placeholder="madymark.com" />
          <Field label="Adres" k="address" icon={MapPin} textarea placeholder="Tahtakale Mah. ..." />
        </div>

        {/* Preview */}
        <div className="space-y-4">
          <div className="bg-white rounded-2xl border border-slate-200 p-6">
            <div className="text-xs uppercase font-bold text-slate-500 tracking-widest mb-4">Önizleme</div>
            <div
              className="p-4 bg-slate-50 rounded-xl border border-slate-200 overflow-auto"
              data-testid="sig-preview"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-3">
            <div className="text-xs uppercase font-bold text-slate-500 tracking-widest">İmzayı Al</div>
            <button
              data-testid="sig-copy-rich"
              onClick={copyRich}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#1E2A9C] text-white font-bold rounded-lg hover:bg-[#161F77] transition"
            >
              <Copy className="w-4 h-4" /> Zengin Metin Olarak Kopyala (Önerilen)
            </button>
            <button
              data-testid="sig-copy-html"
              onClick={copyHTML}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 text-slate-700 font-bold rounded-lg hover:bg-slate-200 transition"
            >
              <Copy className="w-4 h-4" /> HTML Kaynağını Kopyala
            </button>
            <button
              data-testid="sig-download"
              onClick={downloadHTML}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 text-slate-700 font-bold rounded-lg hover:bg-slate-200 transition"
            >
              <Download className="w-4 h-4" /> HTML Dosyası Olarak İndir
            </button>
          </div>
        </div>
      </div>

      {/* Instructions */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border border-blue-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Check className="w-5 h-5 text-[#1E2A9C]" />
          <h2 className="font-black text-lg text-slate-900">Mail İstemcisine Nasıl Eklenir?</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div className="bg-white rounded-xl p-4 border border-slate-200">
            <div className="font-bold text-[#1E2A9C] mb-2">🍎 Apple Mail (Mac)</div>
            <ol className="list-decimal list-inside space-y-1 text-slate-700">
              <li>Mail → Tercihler → İmzalar</li>
              <li>Hesap seç, <b>+</b> ile yeni imza ekle</li>
              <li>Yukarıdan <b>"Zengin Metin Kopyala"</b></li>
              <li>İmza alanına yapıştır (⌘+V)</li>
              <li>"Varsayılan İmzayı Her Zaman Eşle" seç</li>
            </ol>
          </div>
          <div className="bg-white rounded-xl p-4 border border-slate-200">
            <div className="font-bold text-[#1E2A9C] mb-2">📱 Apple Mail (iPhone)</div>
            <ol className="list-decimal list-inside space-y-1 text-slate-700">
              <li>Mac'te önce imzayı Mail'e ekle</li>
              <li>iCloud ile otomatik senkronlanır</li>
              <li>Ayarlar → Mail → İmza → Hesap bazlı seç</li>
              <li>Veya Mac'ten yapıştır ve kaydet</li>
            </ol>
          </div>
          <div className="bg-white rounded-xl p-4 border border-slate-200">
            <div className="font-bold text-[#1E2A9C] mb-2">📧 Gmail / Outlook</div>
            <ol className="list-decimal list-inside space-y-1 text-slate-700">
              <li>Ayarlar → İmza</li>
              <li>Yeni imza oluştur</li>
              <li><b>"Zengin Metin Kopyala"</b> → yapıştır</li>
              <li>Varsayılan olarak işaretle & Kaydet</li>
            </ol>
          </div>
        </div>
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-900">
          <b>Not:</b> Resimler internetten yüklenir. İlk mail gönderiminde alıcı tarafında "resim göster" tıklanırsa logolar görünür.
        </div>
      </div>
    </div>
  );
}
